<template>
  <div class="animated fade-in">
    <h1 class="display-4 font-weight-lighter">Invite Contacts</h1>
    <customer-contact-table :filters="{invited: false}"></customer-contact-table>
  </div>
</template>

<script>

  import CustomerContactTable from "../../../components/customers/contacts/CustomerContactTable";

  export default {
  name: "CustomerContactInvite",
  components: {CustomerContactTable}
};
</script>
